// eslint-disable-next-line no-unused-vars
import axios from 'axios';
import Vue from 'vue';

// eslint-disable-next-line no-unused-vars
const ENDPOINT = `${Vue.prototype.API_ENDPOINT}/graphql`;

export default {
  namespaced: true,

  state: {
    countries: [],
    states: [],
    cities: [],
    institutions: [],
    courses: [],
    companies: [],
    languages: [],
    skills: [],
    genders: [],
    sexual_orientations: [],
    pronouns: [],
    race_and_ethnicities: [],
    personal_incomes: [],
    family_incomes: [],
    maritalStatus: [],
    disabilities: [],
    education_levels: [],
    education_periods: [],
    education_status: [],
    professional_experience_areas: [],
    professional_experience_levels: [],
    cause_experience_areas: [],
    language_proficiencies: [],
  },

  mutations: {
    SET_COUNTRIES(_state, payload) {
      const state = _state;
      state.countries = payload;
      localStorage.setItem('countries', JSON.stringify(payload));
    },

    SET_STATES(_state, payload) {
      const state = _state;
      state.states = payload;
      localStorage.setItem('states', JSON.stringify(payload));
    },

    SET_CITIES(_state, payload) {
      const state = _state;
      state.cities = payload;
      localStorage.setItem('cities', JSON.stringify(payload));
    },

    SET_INSTITUTIONS(_state, payload) {
      const state = _state;
      state.institutions = payload;
      localStorage.setItem('institutions', JSON.stringify(payload));
    },

    SET_COURSES(_state, payload) {
      const state = _state;
      state.courses = payload;
      localStorage.setItem('courses', JSON.stringify(payload));
    },

    SET_COMPANIES(_state, payload) {
      const state = _state;
      state.companies = payload;
      localStorage.setItem('companies', JSON.stringify(payload));
    },

    SET_LANGUAGES(_state, payload) {
      const state = _state;
      state.languages = payload;
      localStorage.setItem('languages', JSON.stringify(payload));
    },

    SET_SKILLS(_state, payload) {
      const state = _state;
      state.skills = payload;
      localStorage.setItem('skills', JSON.stringify(payload));
    },

    SET_GENDERS(_state, payload) {
      const state = _state;
      state.genders = payload;
      localStorage.setItem('genders', JSON.stringify(payload));
    },

    SET_SEXUALORIENTATIONS(_state, payload) {
      const state = _state;
      state.sexual_orientations = payload;
      localStorage.setItem('sexualorientations', JSON.stringify(payload));
    },

    SET_PRONOUNS(_state, payload) {
      const state = _state;
      state.pronouns = payload;
      localStorage.setItem('pronouns', JSON.stringify(payload));
    },

    SET_RACEANDETHNICITIES(_state, payload) {
      const state = _state;
      state.race_and_ethnicities = payload;
      localStorage.setItem('raceandethnicities', JSON.stringify(payload));
    },

    SET_PERSONALINCOMES(_state, payload) {
      const state = _state;
      state.personal_incomes = payload;
      localStorage.setItem('personalincomes', JSON.stringify(payload));
    },

    SET_FAMILYINCOMES(_state, payload) {
      const state = _state;
      state.family_incomes = payload;
      localStorage.setItem('familyincomes', JSON.stringify(payload));
    },

    SET_MARITALSTATUS(_state, payload) {
      const state = _state;
      state.maritalStatus = payload;
      localStorage.setItem('maritalstatus', JSON.stringify(payload));
    },

    SET_DISABILITIES(_state, payload) {
      const state = _state;
      state.disabilities = payload;
      localStorage.setItem('disabilities', JSON.stringify(payload));
    },

    SET_EDUCATIONLEVELS(_state, payload) {
      const state = _state;
      state.education_levels = payload;
      localStorage.setItem('educationlevels', JSON.stringify(payload));
    },

    SET_EDUCATIONPERIODS(_state, payload) {
      const state = _state;
      state.education_periods = payload;
      localStorage.setItem('educationperiods', JSON.stringify(payload));
    },

    SET_EDUCATIONSTATUS(_state, payload) {
      const state = _state;
      state.education_status = payload;
      localStorage.setItem('educationstatus', JSON.stringify(payload));
    },

    SET_PROFESSIONALEXPERIENCEAREAS(_state, payload) {
      const state = _state;
      state.professional_experience_areas = payload;
      localStorage.setItem('professionalexperienceareas', JSON.stringify(payload));
    },

    SET_PROFESSIONALEXPERIENCELEVELS(_state, payload) {
      const state = _state;
      state.professional_experience_levels = payload;
      localStorage.setItem('professionalexperiencelevels', JSON.stringify(payload));
    },

    SET_CAUSEEXPERIENCEAREAS(_state, payload) {
      const state = _state;
      state.cause_experience_areas = payload;
      localStorage.setItem('causeexperienceareas', JSON.stringify(payload));
    },

    SET_LANGUAGEPROFICIENCIES(_state, payload) {
      const state = _state;
      state.language_proficiencies = payload;
      localStorage.setItem('languageproficiencies', JSON.stringify(payload));
    },
  },

  getters: {},

  actions: {
    getLocalDomains({
      state,
      commit,
    }) {
      Object.keys(state).forEach((key) => {
        const domain = localStorage.getItem(key.toLowerCase().replace(/_/g, ''));
        if (domain) {
          const setter = `SET_${key.toUpperCase().replace(/_/g, '')}`;
          commit(`${setter}`, JSON.parse(domain));
        }
      });
    },
  },

};
